const AlertImages = (function () {
    let config = {
        userId: 0,
        id:0
    };
    function AlertImages(customConfig) {
        // Merge customConfig with default config
        config = this.config = Object.assign({}, customConfig);
        if (this.config.id != 0) {
            Echo.channel('public.alert-images.' + this.config.id)
                .subscribed((channel) => {
                    console.log(config);
                })
                .error((e) => {
                    console.log(e);
                })
                .listen('update-action', (e) => {
                    setTimeout(function () {
                        window.location.reload();
                    }, 1000);
                });
        }
    if (this.config.userId != 0) {
        Echo.channel('public.alerts.' + this.config.userId)
            .subscribed((channel) => {
                console.log(config);
            })
            .error((e) => {
                console.log(e);
            })
            .listen('alert-received', (e) => {
                console.log(e);
                // get from local storage if audioNotifications is enabled or not set
                var audioNotifications = localStorage.getItem('audioNotifications') || 'enabled';
                if (audioNotifications === 'enabled') {
                    var audio = document.getElementById('dingSound');
                    audio && audio.play();
                }
                addNotification && addNotification(e);
                var speechNotifications = localStorage.getItem('speechNotifications') || 'disabled';
                if (speechNotifications === 'enabled') {
                    if (speechSynthesis) {
                        if (speechSynthesis.speaking) {
                            speechSynthesis.cancel(); // Cancel the current speech
                        }
                        var utterance = new SpeechSynthesisUtterance(e.message);
                        speechSynthesis.speak(utterance);
                    }
                }
            })
            .listen('alert-read', (e) => {
                console.log(e);
                // get from local storage if audioNotifications is enabled or not set
                removeNotification && removeNotification(e);
            });
    }

    }
    return AlertImages;
    // Public API
})();

window.AlertImages = AlertImages;
export default AlertImages;
